export const NOTIFICATION_VIEW_DELAY = 5000; // 5 seconds

export function getNotificationTimestamp(gatewayId: string): number {
  const stored = localStorage.getItem(`notification-timestamp-${gatewayId}`);
  return stored ? parseInt(stored, 10) : 0;
}

export function setNotificationTimestamp(gatewayId: string): void {
  localStorage.setItem(
    `notification-timestamp-${gatewayId}`, 
    Math.floor(Date.now() / 1000).toString()
  );
}

export function getUnreadNotificationCount(
  gatewayId: string, 
  messages: any[],
  lastViewTimestamp?: number
): number {
  const timestamp = lastViewTimestamp ?? getNotificationTimestamp(gatewayId);
  return messages?.filter(msg => msg.timestamp > timestamp).length ?? 0;
} 